import React from 'react';
import PropTypes from 'prop-types';
import Highlight, { defaultProps } from 'prism-react-renderer';
import Theme from 'prism-react-renderer/themes/vsDark';

const vsDark = {
	styles: [
		...Theme.styles,
		{ types: ['keyword'], style: { color: '#d78ac9' } },
	],
	plain: { ...Theme.plain, backgroundColor: 'rgb(56, 55, 55)' },
};

const CodeReadOnly = (props) => {
	return (
		<Highlight {...defaultProps} theme={vsDark} language='jsx' {...props}>
			{({ className, style, tokens, getLineProps, getTokenProps }) => (
				<pre
					className={`code-read-only ${className}`}
					style={{ ...style, ...props.style }}>
					{tokens.map((line, i) => (
						<div {...getLineProps({ line, key: i })}>
							{line.map((token, key) => (
								<span {...getTokenProps({ token, key })} />
							))}
						</div>
					))}
				</pre>
			)}
		</Highlight>
	);
};

CodeReadOnly.propTypes = {
	code: PropTypes.string.isRequired,
};

CodeReadOnly.defaultProps = {
	style: {},
};

export default CodeReadOnly;
